import React, { FC } from 'react';
import { IconProps } from '.';
import images from '../../../assets/images/images';
import { Image } from '../../../components/';
import { useIntl } from 'react-intl';

export const CloseIcon: FC<IconProps> = ({ size = 24, isSVGtoImage = false, ...props }) => {
    const sizing = { width: size, height: size };
    const intl = useIntl();

    /**
     * use image to avoid ios conflicts with svg
     * either modalClose or close
     * based on ux match
     */

    if (isSVGtoImage)
        return (
            <Image
                src={images.modalClose}
                alt="CLOSE"
                width="9px"
                height="9px"
                aria-label={intl.formatMessage({ id: 'CLOSE' })}
            />
        );

    //for rest places on web, android - if getting used
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...sizing} {...props}>
            <path stroke="currentColor" d="m6 6 6 6 6-6M18 18l-6-6-6 6" />
        </svg>
    );
};
